export default "__VITE_ASSET__7287acdc__"